<iss-form-field [showNecessity]="showNecessity">
  <iss-label>{{ label || ('iss-wo-common.label.supplier' | translate) }}</iss-label>
  <wo-supplier-input
    data-e2e="supplier input"
    [formControl]="control.control"
    [readonly]="readonly"
    [withAll]="withAll"
    [placeholder]="placeholder"
    [available]="available"
    [role]="role"
    [country]="country"
    [isTreatmentFacility]="isTreatmentFacility"
    [multi]="multi"
    [loading]="loading"
    [forceTypeahead]="forceTypeahead"
    [clearable]="clearable"
    [secondaryLabelFn]="secondaryLabelFn"
  >
    <ng-content/>
  </wo-supplier-input>
  <ng-template issFormFieldError let-errors>
    <ng-container *ngIf="errors.required">{{ 'iss-core.error.required' | translate }}</ng-container>
  </ng-template>
</iss-form-field>
